import React, { useEffect, useRef, useState } from 'react';

const BMBackPriceBox = ({
  runner,
  config,
  value,
  checkMaxOdds,
  validationBM,
  getLock,
  handleOnBackClick,checkSuspendedMatchOdds,
  getBMBoxValue,
}) => {
  const [highlighted, setHighlighted] = useState(['', '', '']);
  const prevPricesRef = useRef([
    { price: null, size: null },
    { price: null, size: null },
    { price: null, size: null },
  ]);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      for (let i = 0; i < 3; i++) {
        prevPricesRef.current[i] = {
          price: runner.backPrices?.[i]?.price,
          size: runner.backPrices?.[i]?.size,
        };
      }
      return;
    }

    const newHighlights = ['', '', ''];

    for (let i = 0; i < 3; i++) {
      const current = runner.backPrices?.[i];
      const prev = prevPricesRef.current[i];

      if (current?.price !== prev?.price || current?.size !== prev?.size) {
        if (current?.price > prev?.price) {
          newHighlights[i] = 'higilighted';
        } else if (current?.price < prev?.price) {
          newHighlights[i] = 'higilighted';
        }

        prevPricesRef.current[i] = { price: current?.price, size: current?.size };

        setTimeout(() => {
          setHighlighted((prev) => {
            const updated = [...prev];
            updated[i] = '';
            return updated;
          });
        }, 500);
      }
    }

    setHighlighted(newHighlights);
  }, [runner.backPrices]);

  return (
    <>
      {[0].map((i) => {
        const price = runner.backPrices?.[i]?.price ?? 0;
        const boxValue = runner.backPrices?.[i];
        const disabled = checkMaxOdds(value?.marketId, price);

        return (
          <span
            key={i}
            className={`blue ${disabled ? '' : 'disable'} ${highlighted[i]}`}
            onClick={() => validationBM(price) ?
              handleOnBackClick(runner, config.back, value.marketId, price, config.isNotfancy, value) :''
            }
          >
            {validationBM(price) && !checkSuspendedMatchOdds ? getBMBoxValue(boxValue,value.marketId,runner,value) : getLock()}
          </span>
        );
      })}
    </>
  );
};

export default BMBackPriceBox;
